import { Reveal, Splash } from "./decor";
import { Check, Sparkles } from "lucide-react";
import { useBooking } from "../BookingContext";

export const ConsultingSection = ({ t }) => {
  const { openBooking } = useBooking();
  return (
    <section id="consulting" className="relative overflow-hidden bg-[#FAFAFA] py-24 lg:py-32">
      <Splash className="left-[-140px] top-24 h-[420px] w-[420px]" color="#00C853" />
      <Splash className="right-[-120px] bottom-10 h-[380px] w-[380px]" color="#0066FF" delay={0.2} />

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-6 lg:grid-cols-2 lg:px-10">
        <Reveal className="order-2 lg:order-1">
          <p className="mb-4 flex items-center gap-2 text-sm font-bold uppercase tracking-[0.3em] text-[#00C853]">
            <Sparkles className="h-4 w-4" /> {t.consulting.eyebrow}
          </p>
          <h2 className="font-display text-4xl font-black leading-tight tracking-tight text-black sm:text-5xl">
            {t.consulting.title}
          </h2>
          <p className="mt-6 text-lg font-semibold text-black/80">{t.consulting.lead}</p>
          <p className="mt-4 text-base leading-relaxed text-black/60">{t.consulting.body}</p>

          <ul className="mt-8 space-y-3">
            {t.consulting.bullets.map((b, i) => (
              <li key={i} className="flex items-start gap-3" data-testid={`consulting-bullet-${i}`}>
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#00C853] text-white">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} />
                </span>
                <span className="text-base text-black/75">{b}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={() => openBooking("kids")}
            data-testid="consulting-book-button"
            className="mt-9 inline-block rounded-full bg-[#0066FF] px-8 py-4 text-base font-bold text-white shadow-[0_8px_0_0_#0047b3] transition-all hover:-translate-y-0.5 hover:shadow-[0_10px_0_0_#0047b3]"
          >
            {t.consulting.cta}
          </button>
        </Reveal>

        <Reveal delay={0.15} className="order-1 lg:order-2">
          <div className="relative mx-auto max-w-md">
            <div className="absolute -left-6 -top-6 rounded-full bg-[#FFD600] px-5 py-2 text-sm font-black text-black shadow-lg z-10">
              0–8
            </div>
            <div className="overflow-hidden rounded-[2.5rem] border border-black/10 shadow-[0_40px_100px_-30px_rgba(0,102,255,0.4)]">
              <img
                src="https://images.unsplash.com/photo-1758687126981-417a59c589a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwzfHxwYXJlbnQlMjByZWFkaW5nJTIwd2l0aCUyMGNoaWxkJTIwaGFwcHl8ZW58MHx8fHwxNzg3Mjk5MDY2fDA&ixlib=rb-4.1.0&q=85"
                alt="Parent reading with child"
                className="h-[520px] w-full object-cover"
                data-testid="consulting-image"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 rounded-2xl border border-black/10 bg-white px-5 py-4 shadow-xl">
              <p className="font-display text-3xl font-black text-[#00C853]">2+</p>
              <p className="text-xs font-semibold text-black/50">languages</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
